import styled from "styled-components";
import ChargeListTable from "./chargeListTable";
import { text } from "stream/consumers";
import CellComponent from "./cellComponent";
import { formatDate } from "../../types/types";
import { forEachChild } from "typescript";
import { carryType } from "../../types/types";
import { useEffect } from "react";

const Container = styled.div`
  width: 90vw;
  height: 127vw;
  align-items: center;
  background-color: white;
`;

const Wrapper2 = styled.div`
  width: 87vw;
  height: 127vw;
  margin: 0 auto;
  color: #000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 10vw;
  margin-top: 2vw;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 23vw;
    height: auto;
  }

  h1 {
    font-size: 2.5vw;
    color: #ff4500;
    margin-left: 1vw;
  }
`;
const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
const Date = styled.div`
  font-size: 1.5vw;
  font-weight: 300;
`;

const ChargeTitleContainer = styled.div`
  width: 34vw;
  display: flex;
  justify-content: end;
`;

const ChargeTitle = styled.div`
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 1vw;
  text-align: end;
`;

const ChargeTitle2 = styled.div`
  min-width: 3vw;
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 1vw;
  text-align: end;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 87vw;
  height: 110vw;
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 2.8vw;
`;

const HeaderSplitArea = styled.div`
  width: 43.2vw;
  height: 100%;
  display: flex;
`;

const SideArea = styled.div`
  width: 43.2vw;
  height: 100%;
  display: flex;
  border-top: 0.1vw solid black;
  /* border-left: 1px solid black; */
`;

const BlankArea = styled.div`
  width: 43.2vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.1vw solid black;
  font-size: 3vw;
  color: #656565;
  background-color: #f4f4f4;
  writing-mode: vertical-lr;
`;

const RoomNameArea = styled.div`
  width: 3.2vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-collapse: collapse;
  /* border-top: 1px solid black; */
  /* border-left: 1px solid black; */
`;

const RoomName = styled.div<{
  length: number;
  $index: number;
  $maxIndex: number;
}>`
  border-collapse: collapse;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  font-size: ${(props) => (props.length <= 2 ? "1.1vw" : "1.8vw")};
  text-align: center;
  background-color: #f4f4f4;
  height: ${(props) => `${props.length * 2.6}vw`};
  /* border-bottom: ${(props) =>
    props.$index === props.$maxIndex - 1 ? "none" : "1px solid black"}; */
  border-bottom: 0.1vw solid black;
  border-right: 0.1vw solid black;
  border-left: 0.1vw solid black;
`;

const CellArea = styled.div`
  width: 40vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-collapse: collapse;
`;

const NameBox = styled.div<{
  width: string;
}>`
  border-collapse: collapse;
  width: ${(props) => props.width};
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 1.5vw;
  font-weight: 300;
  border-right: 0.1vw solid black;
  border-bottom: 0.1vw solid black;
  padding-left: 0.6vw;
`;

const SumBox = styled.div<{
  width: string;
}>`
  border-collapse: collapse;
  width: ${(props) => props.width};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8vw;
  font-weight: 500;
  border-right: 0.1vw solid black;
  border-bottom: 0.1vw solid black;
  padding-left: 0.6vw;
  background-color: #f4f4f4;
`;

const QuantityBox = styled.div<{
  width: string;
}>`
  border-collapse: collapse;
  width: ${(props) => props.width};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4vw;
  font-weight: 300;
  border-right: 0.1vw solid black;
  border-bottom: 0.1vw solid black;
`;

const CellItemBox = styled.div`
  width: 100%;
  height: 2.6vw;
  display: flex;
  border-collapse: collapse;
`;

const ContentsArea = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 103.9vw;
  margin-top: 0.2vw;
  border-collapse: collapse;
`;

const HeaderItem = styled.div<{
  width?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6vw;
  font-weight: 600;
  width: ${(props) => props.width};
  height: 100%;
  border-top: 0.1vw solid #606060;
  border-bottom: 0.1vw solid #606060;
  border-left: 0.1vw solid #606060;
  border-right: ${(props) => (props.$isLast ? "0.1vw solid #606060;" : "")};
  background-color: #f4f4f4;
`;

// 1. 각 룸의 길이 총합 + 전체 룸의 갯수(소계 영역을 위해)  <= 80(왼쪽 40개 + 오른쪽 40개) 인 경우만 일단 고려

// 2. 각 룸의 요소들을 전부 map으로 돌려서 길이가 80인 새로운 cellList 만듦.

// 3. 왼쪽영역은 cellList[0:40], 오른쪽영역은 cellList[40:80] 까지로 만든다.

// 4. 각 cellList의 왼쪽부분은 따로 제작

// 5. 오른쪽 영역 없는 경우 여백 처리

function ChargeExportItemPage(props: any) {
  const { chargeList, currentPage, contractDate, currentId } = props;
  const data = chargeList[currentPage - 1];
  const carryTypeList = carryType;
  const cellList: any = [];
  const leftNameList: any = [];
  const rightNameList: any = [];
  // let leftNameData = { id: roomId, length: room.itemList.length, roomName: room.name }

  let countId = 0;
  let splitRoomId = 100;
  let splitItemId = 100;
  let isSplit: boolean = false;

  data.roomList.forEach((room: any, roomId: number) => {
    if (room.itemList.length > 0) {
      room.itemList.forEach((item: any, itemId: number) => {
        let newCellData = {
          id: countId,
          roomId: roomId,
          name: `[${item.category}] ${item.item}`,
          quantity: item.quantity,
          cbm: item.cbm,
          carryType: item.carryType,
          isSum: false,
        };
        cellList.push(newCellData);
        countId++;
        if (countId === 40) {
          splitRoomId = newCellData.roomId;
          splitItemId = itemId;
          isSplit = true;
        }
      });

      // 룸하나 끝나면 소계 데이터 생성 및 넣기
      let sumData = {
        id: countId,
        roomId: roomId,
        name: "소계",
        quantity: room.quantity,
        cbm: room.cbm,
        carryType: 0,
        isSum: true,
      };
      cellList.push(sumData);
      countId++;
      if (countId === 41) {
        splitRoomId = sumData.roomId;
        isSplit = true;
      }
    }
  });

  if (isSplit) {
    data.roomList
      .slice(0, splitRoomId + 1)
      .forEach((room: any, index: number) => {
        if (room.itemList.length > 0) {
          let newData = {
            id: room.roomId,
            length:
              index === splitRoomId
                ? splitItemId + 1
                : room.itemList.length + 1,
            roomName: room.name,
          };
          leftNameList.push(newData);
        }
      });

    data.roomList.slice(splitRoomId, 80).forEach((room: any, index: number) => {
      if (room.itemList.length === 0) {
        return;
      }
      let newData = {
        id: room.roomId,
        length:
          index === 0
            ? room.itemList.length - splitItemId
            : room.itemList.length + 1,
        roomName: room.name,
      };
      rightNameList.push(newData);
    });
  } else {
    // 왼쪽에만 물품정보가 나타날때
    data.roomList
      .slice(0, splitRoomId + 1)
      .forEach((room: any, index: number) => {
        if (room.itemList.length > 0) {
          let newData = {
            id: room.roomId,
            length:
              index === splitRoomId
                ? splitItemId + 1
                : room.itemList.length + 1,
            roomName: room.name,
          };
          leftNameList.push(newData);
        }
      });
  }

  return (
    <Container className={`companyContractPage${currentId}`}>
      <Wrapper2>
        <Header>
          <Logo>
            <img src="/icon/tonginLogo.png" alt="Logo" />
          </Logo>
          <DateContainer>
            <ChargeTitleContainer>
              <ChargeTitle>물품내역서</ChargeTitle>
              <ChargeTitle2>{currentPage}</ChargeTitle2>
            </ChargeTitleContainer>
            <Date>DATE : {formatDate(contractDate)}</Date>
          </DateContainer>
        </Header>
        <Wrapper>
          <HeaderArea>
            <HeaderSplitArea>
              <HeaderItem width="26.2vw">항목</HeaderItem>
              <HeaderItem width="5vw">수량</HeaderItem>
              <HeaderItem width="6vw">부피</HeaderItem>
              <HeaderItem width="6vw" $isLast>
                처리
              </HeaderItem>
            </HeaderSplitArea>
            <HeaderSplitArea>
              <HeaderItem width="26.2vw">항목</HeaderItem>
              <HeaderItem width="5vw">수량</HeaderItem>
              <HeaderItem width="6vw">부피</HeaderItem>
              <HeaderItem width="6vw" $isLast>
                처리
              </HeaderItem>
            </HeaderSplitArea>
          </HeaderArea>
          <ContentsArea>
            {cellList.length === 0 ? (
              <BlankArea>여백 영역</BlankArea>
            ) : (
              <SideArea>
                <RoomNameArea>
                  {leftNameList.map((item: any, index: number) => {
                    return (
                      <RoomName
                        key={index}
                        $index={index}
                        $maxIndex={leftNameList.length}
                        length={item.length}
                      >
                        {item.roomName}
                      </RoomName>
                    );
                  })}
                </RoomNameArea>
                <CellArea>
                  {cellList.slice(0, 40).map((item: any, index: number) => {
                    return (
                      <CellItemBox key={index}>
                        {item.isSum ? (
                          <>
                            <SumBox width="23.3vw">소 계</SumBox>
                            <QuantityBox width="5vw">
                              {item.quantity}
                            </QuantityBox>
                            <QuantityBox width="6vw">{item.cbm}</QuantityBox>
                            <QuantityBox width="6vw"></QuantityBox>
                          </>
                        ) : (
                          <>
                            <NameBox width="23.3vw">{item.name}</NameBox>
                            <QuantityBox width="5vw">
                              {item.quantity}
                            </QuantityBox>
                            <QuantityBox width="6vw">{item.cbm}</QuantityBox>
                            <QuantityBox width="6vw">
                              {carryTypeList[item.carryType].status}
                            </QuantityBox>
                          </>
                        )}
                      </CellItemBox>
                    );
                  })}
                </CellArea>
              </SideArea>
            )}

            {isSplit ? (
              <SideArea>
                <RoomNameArea>
                  {rightNameList.map((item: any, index: number) => {
                    return (
                      <div key={index}>
                        {index === 0 && item.length <= 2 ? (
                          <RoomName
                            key={index}
                            $index={index}
                            $maxIndex={rightNameList.length}
                            length={item.length}
                          ></RoomName>
                        ) : (
                          <RoomName
                            key={index}
                            $index={index}
                            $maxIndex={rightNameList.length}
                            length={item.length}
                          >
                            {item.roomName}
                          </RoomName>
                        )}
                      </div>
                    );
                  })}
                </RoomNameArea>
                <CellArea>
                  {cellList.slice(40, 80).map((item: any, index: number) => {
                    return (
                      <CellItemBox key={index}>
                        {item.isSum ? (
                          <>
                            <SumBox width="23.3vw">소 계</SumBox>
                            <QuantityBox width="5vw">
                              {item.quantity}
                            </QuantityBox>
                            <QuantityBox width="6vw">{item.cbm}</QuantityBox>
                            <QuantityBox width="6vw"></QuantityBox>
                          </>
                        ) : (
                          <>
                            <NameBox width="23.3vw">{item.name}</NameBox>
                            <QuantityBox width="5vw">
                              {item.quantity}
                            </QuantityBox>
                            <QuantityBox width="6vw">{item.cbm}</QuantityBox>
                            <QuantityBox width="6vw">
                              {carryTypeList[item.carryType].status}
                            </QuantityBox>
                          </>
                        )}
                      </CellItemBox>
                    );
                  })}
                </CellArea>
              </SideArea>
            ) : (
              <BlankArea>여백 영역</BlankArea>
            )}
          </ContentsArea>
        </Wrapper>
      </Wrapper2>
    </Container>
  );
}

export default ChargeExportItemPage;
